import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { EUserRole } from '@/enum';
import { createEncryptedStorage } from '@/utils/encryption';

type TUser = {
  token?: string;
  name: string;
  email: string;
  is_access: EUserRole | null;
  profile_pic?: string;
};

type TStore = {
  user: TUser;
  setUser: (_user: TUser) => void;
};

export const USER_INIT_STATE: TUser = {
  token: '',
  name: '',
  email: '',
  is_access: null,
  profile_pic: '',
};

const useUser = create<TStore>()(
  persist(
    (set) => ({
      user: USER_INIT_STATE,
      setUser: (user) => set({ user }),
    }),
    {
      name: 'supporting-properties',
      storage: createEncryptedStorage<TStore>(),
    }
  )
);

export default useUser;
